import getAppState from 'app-state';

let init = false;

/**
 * Injects the app-state system into the RCM config system
 *
 * After calling this, calls to rcm.getConfigValue() will defer to the app state
 * system before looking for values from RCM config.
 */
export default function injectIntoRcmConfig() {
    if (init) {
        return;
    }
    init = true;

    if (!window.rcm || !window.rcm.getConfigValue) {
        throw new Error('Cannot bind app state system to Rcm config; rcm object is not defined.');
    }

    const rcmGetConfigValue = window.rcm.getConfigValue;
    window.rcm.getConfigValue = (key, def) => {
        return getAppState(key, rcmGetConfigValue(key, def));
    };
}
